// Column meta config for the vehicle search table in the Data Download flow.
// valueRenderingType values are handled by TableColumnValueRenderer.
// To add/remove/reorder columns per org, update VEHICLE_COLUMN_ORDER.

export const VEHICLE_TABLE_COLUMNS = {
  licensePlateNo: {
    key: "licensePlateNo",
    title: "Bus Number",
    width: 150,
    sorter: false,
    dataIndex: "licensePlateNo",
    defaultValue: "—",
    valueRenderingType: "device-id-link",
    disableActiveStatus: true, // no ping-status dot
  },
  deviceID: {
    key: "deviceID",
    title: "IMEI",
    width: 180,
    sorter: false,
    dataIndex: "deviceID",
    defaultValue: "—",
    valueRenderingType: "text",
  },
  originState: {
    key: "originState",
    title: "State",
    width: 120,
    sorter: false,
    dataIndex: "originState",
    defaultValue: "—",
    valueRenderingType: "text",
  },
  originCity: {
    key: "originCity",
    title: "City",
    width: 120,
    sorter: false,
    dataIndex: "originCity",
    defaultValue: "—",
    valueRenderingType: "text",
  },
  originDepo: {
    key: "originDepo",
    title: "Depot",
    width: 140,
    sorter: false,
    dataIndex: "originDepo",
    defaultValue: "—",
    valueRenderingType: "text",
  },
  vin: {
    key: "vin",
    title: "Chassis Number",
    width: 180,
    sorter: false,
    dataIndex: "vin",
    defaultValue: "—",
    valueRenderingType: "text-with-copy",
    copyToClipBoardTypeName: "Chassis Number",
  },
};

export const VEHICLE_COLUMN_ORDER = [
  "licensePlateNo",
  "deviceID",
  "vin",
  "originState",
  "originCity",
  "originDepo",
];
